<template>
  <div class="h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
    <!-- 聊天记录区域 -->
    <div class="flex-1 overflow-y-auto p-4 space-y-4" ref="chatContainer" style="max-height: calc(100vh - 100px);">
      <template v-for="(message, index) in messages" :key="index">
        <chat-bubble
          :content="message.content"
          :isAI="message.isAI"
          :isMarkdown="message.isMarkdown"
          :isLoading="message.isLoading"
        />
      </template>
    </div>

    <!-- 输入框区域 - 固定在底部 -->
    <div class="w-full bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg">
      <chat-input 
        ref="chatInput"
        @send="handleSend" 
        :disabled="isLoading"
      />
    </div>
  </div>
</template>

<script>
import ChatBubble from '@/components/ChatBubble.vue'
import ChatInput from '@/components/ChatInput.vue'
import { chatService } from '@/services/chatService'
import { API_CONFIG } from '@/config/api'

export default {
  name: 'Chat',
  components: {
    ChatBubble,
    ChatInput
  },
  data() {
    return {
      messages: [
        {
          content: '你好！我是 AI 助手，有什么我可以帮你的吗？',
          isAI: true,
          isMarkdown: false
        }
      ],
      isLoading: false
    }
  },
  methods: {
    async handleSend(message) {
      // 添加用户消息
      this.messages.push({
        content: message,
        isAI: false,
        isMarkdown: false
      })

      // 添加 AI 消息占位
      const aiMessageIndex = this.messages.length
      this.messages.push({
        content: '正在思考...',
        isAI: true,
        isMarkdown: false,
        isLoading: true
      })

      this.scrollToBottom()
      this.isLoading = true
      this.checkPendingQuestion()

      try {
        // 调用 API
        const response = await chatService.sendMessage(
          this.messages.slice(0, -1).map(msg => ({
            content: msg.content,
            isAI: msg.isAI
          }))
        )
        
        // 更新 AI 回复
        this.messages[aiMessageIndex] = {
          content: response,
          isAI: true,
          isMarkdown: true,
          isLoading: false
        }
      } catch (error) {
        console.error('Chat error:', error)
        // 处理错误
        this.messages[aiMessageIndex] = {
          content: error.message || '抱歉，我遇到了一些问题。请稍后再试。',
          isAI: true,
          isMarkdown: false,
          isLoading: false,
          isError: true
        }
      } finally {
        this.isLoading = false
        this.scrollToBottom()
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer
        container.scrollTop = container.scrollHeight
      })
    },
    checkPendingQuestion() {
      const pendingQuestion = localStorage.getItem('pendingQuestion')
      if (pendingQuestion) {
        // 清除存储的问题
        localStorage.removeItem('pendingQuestion')
        // 设置输入框的值并发送
        this.$refs.chatInput.setMessage(pendingQuestion)
        this.handleSend(pendingQuestion)
      } else {
        // 如果没有待处理的问题，清空输入框
        this.$refs.chatInput.setMessage('')
      }
    }
  },
  mounted() {
    // 检查是否有待处理的问题
    this.$nextTick(() => {
      this.checkPendingQuestion()
    })
  }
}
</script>

<style scoped>
.sticky {
  position: sticky;
  bottom: 0;
  z-index: 10;
}
</style> 